import "core-js/modules/es.array.push.js";
import { ref } from 'vue';
import { Search, Popup, Button, Checkbox, CheckboxGroup, Tab, Tabs, Col, Row, closeToast, showLoadingToast, showDialog } from 'vant';
import { useRouter } from 'vue-router';
import { postue } from '../../api/utils/request.ts';
export default {
  setup() {
    const curType = ref('');
    const checkedlist = ref([]);
    const showScreen = ref(false);
    const sortType = ref('asc');
    const condition = ref('');
    const toggleScreen = t => {
      curType.value = t;
      showScreen.value = true;
    };
    return {
      condition,
      curType,
      showScreen,
      checkedlist,
      toggleScreen,
      sortType
    };
  },
  data() {
    return {
      macTypelist: [],
      //全部设备
      tagList: [],
      //全部标签
      brandList: [],
      //全部品牌
      DrivingMode: [],
      PlatformHigh: [],
      excavatorSizeslist: [],
      //设备大小

      checkTags: [],
      checkhotbrand: [],
      checkMacTypes: [],
      checkmodel: [],
      checkhigh: [],
      checkSize: [],
      isshowother: false,
      isshowtags: 1,
      curType: 1 //1是挖掘机，2、其他设备
    };
  }
  /**
   * 生命周期函数--监听页面加载
   */,

  // onLoad: function (options) {
  //     console.log('onLoad')
  //     var that = this;
  //     const eventChannel = this.getOpenerEventChannel();
  //     eventChannel.on('callback', (data) => {
  //         that.setData({
  //             checkTags: data.data.checkTags,
  //             checkhotbrand: data.data.checkhotbrand,
  //             checkMacTypes: data.data.checkMacTypes,
  //             checkmodel: data.data.checkmodel,
  //             checkhigh: data.data.checkhigh,
  //             checksize: data.data.checksize,
  //             isshowother: data.data.checkMacTypes.indexOf('高空車') == -1 ? false : true,
  //             isshowtags: options.id,
  //             curType: options.ctype
  //         });
  //     });
  // },
  mounted() {
    //在组件被挂载之后调用 
    console.log('mounted');
    this.GetOtherMacType();
  },
  methods: {
    //#region 標籤查詢
    //標籤
    TagcheckChange_tag: function (e) {
      if (this.checkTags.includes(e)) {
        this.checkTags.splice(this.checkTags.indexOf(e), 1);
      } else {
        this.checkTags.push(e);
      }
    },
    //設備
    TagcheckChange_size: function (e) {
      if (this.checkSize.includes(e)) {
        this.checkSize.splice(this.checkSize.indexOf(e), 1);
      } else {
        this.checkSize.push(e);
      }
    },
    //設備
    TagcheckChange_mac: function (e) {
      if (this.checkMacTypes.includes(e)) {
        this.checkMacTypes.splice(this.checkMacTypes.indexOf(e), 1);
      } else {
        this.checkMacTypes.push(e);
      }
      this.isshowother = this.checkMacTypes.indexOf('高空車') == -1 ? false : true;
    },
    //設備--驅動
    TagcheckChange_mac_qd: function (e) {
      if (e == "全部") {
        this.checkmodel = ['全部'];
      } else if (this.checkmodel.includes('全部')) {
        this.checkmodel.pop();
      }
      if (this.checkmodel.includes(e)) {
        this.checkmodel.splice(this.checkmodel.indexOf(e), 1);
      } else {
        this.checkmodel.push(e);
      }
    },
    //設備--平臺高度
    TagcheckChange_mac_gd: function (e) {
      if (e == "全部") {
        this.checkhigh = ['全部'];
      } else if (this.checkhigh.includes('全部')) {
        this.checkhigh.pop();
      }
      if (this.checkhigh.includes(e)) {
        this.checkhigh.splice(this.checkhigh.indexOf(e), 1);
      } else {
        this.checkhigh.push(e);
      }
    },
    //設備
    TagcheckChange_brand: function (e) {
      if (this.checkhotbrand.includes(e)) {
        this.checkhotbrand.splice(this.checkhotbrand.indexOf(e), 1);
      } else {
        this.checkhotbrand.push(e);
      }
    },
    GetOtherMacType: function () {
      showLoadingToast({
        message: '加載中...',
        forbidClick: true,
        duration: 0
      });
      postue('Auction/RTBV2/GetOtherBrand', {}).then(res => {
        console.log(res);
        this.brandList = res.data;
        closeToast();
      });
      postue('Auction/RTBV2/GetOtherTags', {}).then(res => {
        console.log(res);
        this.tagList = res.data;
      });
      postue('Auction/RTBV2/GetOtherMacType', {}).then(res => {
        console.log(res);
        this.macTypelist = res.data.MacTypeList;
        this.DrivingMode = res.data.DrivingModeList;
        this.PlatformHigh = res.data.PlatformHighList;
      });
      postue('Auction/RTBV2/GetShowConditon', {}).then(res => {
        console.log(res);
        this.excavatorSizeslist = res.data.ExcavatorSizes;
      });
    },
    back: function (e) {
      var that = this;
      const eventChannel = that.getOpenerEventChannel();
      eventChannel.emit('callback', {
        tList: that.checkTags,
        bList: that.checkhotbrand,
        macList: that.checkMacTypes,
        modelList: that.checkmodel,
        highList: that.checkhigh,
        sList: that.checksize
      });
    }
  }
};